export const CUSTOMIZE_AND_BUY_PANNEL = 'CUSTOMIZE_AND_BUY_PANNEL';

export const DELETE_PANNEL = 'DELETE_PANNEL';

export const PROJECT_ID_PARAM = ':projectId';

export const VARIATION_ID_PARAM = ':variationId';

export const SOURCE_PARAM = 'buyer_saved_logos';

export const CUSTOMIZE_LINK = `/logo-maker/customize/projects/${PROJECT_ID_PARAM}/variations/${VARIATION_ID_PARAM}?source=${SOURCE_PARAM}`;

export const PACKAGES_LINK = `/logo-maker/projects/${PROJECT_ID_PARAM}/variations/${VARIATION_ID_PARAM}/packages-preview?source=${SOURCE_PARAM}`;
